import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/differenceInCalendarDays/index.js';

var require$$36 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$36 as default };
